import { SelectOption } from "components/forms/Select/Select";
import { useMemo } from "react";
import { useReportsMetaSelector } from "../../store";

const GLOBAL_ITEMS = "General";

export function useMeasures(valuesWithCharacteristics?: boolean): (string | SelectOption)[] {
  const { assetClasses, measures, measureClasses, characteristics, calculatedFields } = useReportsMetaSelector();
  return useMemo(() => {
    const groupedValues: Array<SelectOption | string> = [];
    assetClasses.forEach((ac) => {
      let itemsToPush = ac.measures;
      if (valuesWithCharacteristics) {
        itemsToPush = itemsToPush.concat(ac.characteristics);
      }
      if (itemsToPush.length > 0) {
        groupedValues.push({
          key: ac.title,
          value: ac.title,
          text: ac.title,
          role: "category"
        });
        itemsToPush.forEach((item) =>
          groupedValues.push({
            key: ac.id + "." + item,
            value: item.toString(),
            text: item.toString()
          })
        );
      }
    });
    let itemsToPush = [...measures];
    if (valuesWithCharacteristics) {
      itemsToPush = itemsToPush.concat(measureClasses.map((mc) => mc.title));
      itemsToPush = itemsToPush.concat([...characteristics]);
    }
    if (itemsToPush.length > 0) {
      groupedValues.push({
        key: GLOBAL_ITEMS,
        value: GLOBAL_ITEMS,
        text: GLOBAL_ITEMS,
        role: "category"
      });
      itemsToPush.forEach((item) => groupedValues.push(item));
    }
    // Add Calculated fields to the all values
    groupedValues.push({
      key: "calc-fields-category",
      value: "calc-fields-category",
      text: "Calculated Fields",
      role: "category"
    });
    calculatedFields &&
      calculatedFields.forEach((field) => {
        groupedValues.push({
          key: field,
          value: "calc-field-" + field,
          text: field
        });
      });
    return groupedValues;
  }, [assetClasses, measureClasses, measures, characteristics, valuesWithCharacteristics]);
}
